export const situationsTwo = [
  {
    id: 1,
    text: "His mother is tested Covid positive but the hospital refuses to admit her due to overcrowding of the place. He...",
    response:
      "Took the medicine kit, made the necessary arrangements, quarantined her at home, and followed government guidelines.",
  },
  {
    id: 2,
    text: "Your Business is badly affected due to Covid situation. What will you do...",
    response:
      "Use the saved money, pivot the strategies, take the business online, and start home delivery.",
  },
  {
    id: 3,
    text: "There is a lockdown in your city but one of your friends needs you urgently in the other city. You...",
    response: "Contacted local authority and got permission to commute.",
  },
  {
    id: 4,
    text: "She lives in a hostel and during her examination her mother has been hospitalized. She would...",
    response:
      "Ask father/brother to take care of her, give examination, and left for the hospital.",
  },
  {
    id: 5,
    text: "He is attending a conference. The servant confirms him that his father wants to see him very urgently. He...",
    response:
      "He requested members for a tea break and in meantime contacted his father and inquired about the situation and acted accordingly.",
  },
  {
    id: 6,
    text: "His friend was in love with a girl and he came to know that the girl was cheating on his friend. He...",
    response:
      "He talked to his friend and suggested reconsidering the relationship.",
  },
  {
    id: 7,
    text: "In the SSB he finds that no one is talking to him. Today is the first day. He...",
    response:
      "He took the first move, introduced himself to the group, and made new friends.",
  },
  {
    id: 8,
    text: "Fire broke out in his village and flames are approaching. He...",
    response:
      "Informed the fire brigade, meanwhile alerted and evacuated the villagers and helped in extinguishing the fire",
  },
  {
    id: 9,
    text: "All his friends decided to play volleyball. But he refused to play. All his friends started abusing him. He...",
    response:
      "He cited the reason for not playing and cheered them from outside.",
  },
  {
    id: 10,
    text: "He got information of a possible dacoit raid in the village. He...",
    response:
      "Shared the information with the police, alerted the villagers, and got them caught.",
  },
  {
    id: 11,
    text: "His convoy got stuck on the way due to some problem and the place is prone to terrorists. He...",
    response:
      "Conveyed the team to stay on guard, meanwhile contacted base and asked for assistance.",
  },
  {
    id: 12,
    text: "He is at home and dacoits have reached his apartment and started looting. He...",
    response:
      "Came out of home unnoticed, informed police gathered neighbors, nabbed them, and handed them over to the police.",
  },
  {
    id: 13,
    text: "Emergency has been declared in the city where his unit is located. He is the CO of the unit. He...",
    response: "He contacted the HQ and followed the orders.",
  },
  {
    id: 14,
    text: " While traveling in the train you are playing with a kid, suddenly the gold chain of the baby missing and their parents doubting you. You will...",
    response:
      "Denied the claim, helped in searching the chain, found it, and handed it over to the parents.",
  },
  {
    id: 15,
    text: "You are a fresh graduate of MBA taking in charge of your father’s business and after your leading, there is a sudden fall in business profits and you will...",
    response:
      "Took assistance from father, reanalyzed the strategies, and made a profit.",
  },
  {
    id: 16,
    text: "You are a south Indian and you don’t know Hindi well, while going to SSB at Allahabad, you lost your purse in the train, you will...",
    response:
      "Informed RPF, lodged a complaint, and used e-wallet for necessary works.",
  },
  {
    id: 17,
    text: "His sister called him and told him that she is not feeling well. He was in the mid of the meeting. He...",
    response:
      "Asked brother/father to take her to the hospital, completed the meeting, and thereafter went to the hospital.",
  },
  {
    id: 18,
    text: "He smelled the gas leakage after entering in the house. His family members were busy in some work. He...",
    response:
      "Turned off the gas knob, opened the windows, and alerted the family",
  },
  {
    id: 19,
    text: "One day out of 10 friends her 8 friends stopped talking with her. She would...",
    response: "Talk to them, and remove misunderstandings.",
  },
  {
    id: 20,
    text: "His principal convicted him of beating another college student and decided to rusticate him. He...",
    response:
      "He proved his innocence with eyewitnesses and convinced him to revoke the rustication.",
  },
  {
    id: 21,
    text: "While going over the bridge over a river with his friends, he found half of the party had crossed the river bridge when suddenly the bridge collapsed. He...",
    response:
      "Alerted the remaining members, informed the authority, and found an alternative to reach another side.",
  },
  {
    id: 22,
    text: "Due to heavy rains the river was rising and he had to cross it. He...",
    response: "Waited for the river to get normal or found an alternative way.",
  },
  {
    id: 23,
    text: "As captain of the team, he found his players rather discouraged while playing a match. He...",
    response:
      "Motivated the players, cheered them by chanting team slogan, and won the match.",
  },
  {
    id: 24,
    text: "During the journey, he found some miscreants entering the compartment and trying to loot the passengers. He...",
    response:
      "Overpowered them with the help of co-passengers, nabbed them, and handed them over to the RPF",
  },
  {
    id: 25,
    text: " Due to some misunderstanding a close friend hit him. He...",
    response: "Took it lightly, talked to him, and removed misunderstandings.",
  },
  {
    id: 26,
    text: "The leader of his trekking team decides to take a longer route when time is running out, he...",
    response:
      " He convinced him by showing a shorter route on the map and reached the destination on time.",
  },
  {
    id: 27,
    text: "His father and uncle quarrel over his intended inter‐caste marriage, he...",
    response:
      "He intervenes, puts forward his opinion, convinced them to meet the girl.",
  },
  {
    id: 28,
    text: " He is not satisfied with his life. He...",
    response:
      "Traveled to new places, talked to new people, got new experiences of life, found his passion and goals, and enjoyed life.",
  },
  {
    id: 29,
    text: "At night at the railway station you entered an empty train. You found that a person was raping a woman. You...",
    response:
      "Stoped him using force, handed him over to the RPF, and helped that women lodge a complaint against him.",
  },
  {
    id: 30,
    text: "Her friends have made a picnic program at a place where night stay is necessary as the place is 120 km away. Her parents are opposing. She...",
    response:
      "She convinced her parents with the help of friends and removed their safety concerns, and went to the picnic.",
  },
  {
    id: 31,
    text: "The students of his college are about to call a strike. They want his cooperation. He...",
    response:
      "He convinced them to hold talks with authority and made an amicable settlement.",
  },
  {
    id: 32,
    text: "He had entered the semi-final in the State Badminton Championships. But his opponent was reputed to be too strong. He...",
    response:
      " He didn’t bother, focused on the game, and defeated the opponent.",
  },
  {
    id: 33,
    text: "There was a rush at the platform and the train was about to start but the coolie carrying is luggage could not be traced. He...",
    response:
      "He found the coolie tracing his luggage, entered in the nearest compartment, and later shifted to his compartment with the help of co-passengers.",
  },
  {
    id: 34,
    text: "He is watching the movie in the cinema hall. The hall catches fire. He...",
    response:
      "He made the emergency gate secure and evacuated the people safely.",
  },
  {
    id: 35,
    text: " All his family members are ill and his father is out of town. There is no money in the home. He...",
    response:
      "Took money from friends, admitted them to hospital, informed his father, and repaid when father arrived.",
  },
  {
    id: 36,
    text: "He is the only earning member in his family but also wants to study further. He...",
    response:
      "Took admission in a distance learning program, and studied in his free time.",
  },
  {
    id: 37,
    text: "They decide to give a treat to their retiring professor. He wants to give a dinner party whiles his friends want just a tea‐party. He...",
    response:
      "He persuaded them by showing their professor’s contribution to the college and that he deserves more than just a tea party",
  },
  {
    id: 38,
    text: "He with six persons had gone on a cycle expedition and one cycle got punctured on desert stretched road. He...",
    response:
      "He made him sit on the back carrier and towed the cycle to the nearest mechanic",
  },
  {
    id: 39,
    text: "His exam starts the next day and he is not fully prepared. His father’s close friend has suddenly come to his house, there is no one to entertain him. He...",
    response:
      " Greeted him, informed his father, and told him to wait until his father returned and continued with his study.",
  },
  {
    id: 40,
    text: "He won an expensive watch in a lottery and found it defective. He...",
    response: "He got it repaired and decided not to play in the future.",
  },
  {
    id: 41,
    text: " He is recently appointed in an organization. where he is being given extra workload. He...",
    response:
      "Put on extra efforts, completed the work on time, and won the confidence of his seniors/boss",
  },
  {
    id: 42,
    text: "While undertaking the journey a co-passenger is teasing her. She...",
    response:
      "Took the help of other co-passengers and nabbed him and handed him over to the police",
  },
  {
    id: 43,
    text: "In his village, two leading parties got in conflict during sarpanch election. He...",
    response: "Reported to the local authority and resolved the matter",
  },
  {
    id: 44,
    text: "While passing by he found two people sneaking at a house from the window. He...",
    response:
      "Confronted them, informed the house owner, and warned them for their actions.",
  },
  {
    id: 45,
    text: " He was all set for SSB but unfortunately there was a sad demise of his family member. He...",
    response: "He informed his allotted SSB center and got a new date.",
  },
  {
    id: 46,
    text: "His project was criticized in the exhibition. He...",
    response: "He answered the criticism with facts.",
  },
  {
    id: 47,
    text: "He failed in exams even after bold efforts. He...",
    response:
      "He evaluated his mistakes, changed the strategy, put on extra efforts, and cleared the exam.",
  },
  {
    id: 48,
    text: "When he reached the railway station, he saw his train just crossing the station. He...",
    response: "He took a cab and caught the train at the next station.",
  },
  {
    id: 49,
    text: "He was enjoying the fair with his niece and suddenly he saw rampage on the other side of the fairground. He...",
    response:
      "Ensure the safety of his niece by going to a safe place, informed authority, and left the fair safely.",
  },
  {
    id: 50,
    text: "While going to the attend an examination, he met with an accident and got his left leg severely injured. He...",
    response:
      "He informed the college authority and seek exemption with proof of medical reports.",
  },
  {
    id: 51,
    text: "She has been assigned a difficult task by her teacher which she has not done earlier. She would...",
    response:
      "Accepted the task, took assistance from friends and seniors, and completed the task.",
  },
  {
    id: 52,
    text: "He accompanied by his sister was moving in the market when four persons snatched his sister's purse and ran. He...",
    response:
      "He shouted and ran behind them, nabbed them with the help of passerby's, took the chain back, and handed them over to the police.",
  },
  {
    id: 53,
    text: "In NCC camp, on guard duty he finds two strangers approaching the camp at night. He...",
    response:
      "He alerted his team, inquired the strangers, and acted accordingly.",
  },
  {
    id: 54,
    text: "Electric light of his neighbor has gone off. He...",
    response:
      "Inquired the neighbor, ensured that everyone is safe, called the electrician, and got the problem fixed.",
  },
  {
    id: 55,
    text: "He is passing by a lake, he notices a boy drowning in the water and he does not know swimming. He...",
    response:
      "He shouted and gathered people, pulled the boy out of the lake with other’s help, and gave him CPR.",
  },
  {
    id: 56,
    text: "He is going to attend the SSB. When the train moves, lady falls on the platform. He...",
    response:
      "He jumped off the train, picked up the lady, and jumped right back in.",
  },
  {
    id: 57,
    text: "His classmates decided to complain against one of the lecturers. When he refused, they started avoiding him. He...",
    response:
      "He talked to them, put his opinion forward, and resolved the matter.",
  },
  {
    id: 58,
    text: "Due to a mild quarrel, his elder brother decides to leave the home. He...",
    response:
      "He stopped him, calmed him down, and resolved the matter with a family intervention.",
  },
  {
    id: 59,
    text: "She loves a boy and she would like to marry with him but he is refusing. She would...",
    response: "She expressed her feeling and accepted the decision of the boy.",
  },
  {
    id: 60,
    text: "His friend proposed a plan to bribe lecturer for passing the college examination. He...",
    response:
      "He refused and also stopped them stating it is illegal and unethical to pass the examination this way.",
  },
];
